import React from 'react';
import Profilesidebar from '../components/Element/ClientSidebar';
import AssesmentCategoryProfile from '../components/Element/AssesmentCategoryProfile';
const AssesmentCategory = (props) => {
	return (
		<React.Fragment>
			<div className="page-content bg-white">
				<div className="content-block">
					<div className="section-full bg-white browse-job p-t50 p-b20">
						<div className="container">
							<div className="row">
								<Profilesidebar page="assesment-categories" />
								<div className="col-xl-9 col-lg-8 m-b30">
									<AssesmentCategoryProfile />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	)
}


export default AssesmentCategory;